import type { AxiosError } from 'axios'

/** Clave única por venta para que el servidor no la duplique en reintentos. */
export function nuevaClave(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `pos-${crypto.randomUUID()}`
  }
  const rand = () => Math.random().toString(36).slice(2, 10)
  return `pos-${Date.now().toString(36)}-${rand()}${rand()}`
}

/**
 * Un error "de red" es el que no trae respuesta del servidor: sin conexión,
 * DNS, timeout. Un 4xx/5xx sí llegó al servidor y no se debe reintentar a ciegas.
 */
export function esErrorDeRed(error: unknown): boolean {
  const ax = error as AxiosError | undefined
  if (!ax || typeof ax !== 'object') return false
  if (ax.response) return false
  return ax.code === 'ERR_NETWORK' || ax.code === 'ECONNABORTED' || ax.code === 'ETIMEDOUT' || !!ax.request
}
